// src/i18n.js
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

i18n
  .use(Backend) // Load translations from server
  .use(LanguageDetector) // Detect language automatically
  .use(initReactI18next) // Bind react-i18next to i18next
  .init({
    fallbackLng: 'en', // Fallback language if the detected language is unavailable
    debug: true, // Enable debugging
    interpolation: {
      escapeValue: false // React already escapes values
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json' // Path to translation files
    }
  })

export default i18n
